import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useIdelinkTheme } from '../../../configs/IdeLinkTheme';
import { AdminPermission } from '../../../services/commons/Me';
import {
    AdminPermissions,
    AdminPermissionsOnModule,
} from '../../../services/commons/Permissions/AdminPermissions';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';
import { TabPermissionItem } from '../../BackUsers/Pages/components/PermissionsTreeContainer/PermissionsTreeContainer';

export class GondolesPermissions {
    public static GONDOLES_TAB_HASH = '#rights-gondoles';
    public static GONDOLES_CODE = 'Gondolas';

    public static Admin: AdminPermissionsOnModule = {};

    public static getGondolesTab = (): TabPermissionItem => ({
        hash: GondolesPermissions.GONDOLES_TAB_HASH,
        label: <FormattedMessage id="gondoles.permissions.tab.title" />,
        getIcon: () => useIdelinkTheme().gondoles.permissionIcon,
        getIconSelected: () => useIdelinkTheme().gondoles.permissionSelectedIcon,
    });

    public static initializeGondolesAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnGondoles = AdminPermissions.filter(perms, GondolesPermissions.GONDOLES_CODE);
        GondolesPermissions.Admin = AdminPermissions.toPermissions(permsOnGondoles);
        PermissionsAbilityHelper.logPermissions('Gondoles', GondolesPermissions.Admin);
    };
}
